import { Button } from '@hai/ui-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAdaptiveFetch } from 'src/js/hook/use-adaptive-fetch';
import { useStores } from 'src/js/hook/use-stores';
import { StatisticTable } from 'src/js/pages/statistic/statistic-table';

import { ScteViewModel } from './scte-models';
import { mapScteToStatistics } from './scte-statistics-content';
import { fetchScteStatistics, resetScteStatistics } from './scte-store';

interface Props {
  model: ScteViewModel;
}

export const ScteStatistics: React.FunctionComponent<Props> = ({ model }) => {
  const { t } = useTranslation();
  const { sessionStore } = useStores();

  const [data, setData] = useState(model);
  useAdaptiveFetch(() => fetchScteStatistics(model, t, setData), 5000);

  const handleResetStatistics = () => {
    resetScteStatistics(model, t, setData);
  };

  return (
    <>
      <div className="mk-stats-container">
        <StatisticTable sections={mapScteToStatistics(data, t)} />
      </div>
      {!sessionStore.isUser() && (
        <div className="d-flex hai-mt-4">
          <Button className="ml-auto" variant="secondary" onClick={handleResetStatistics}>
            {t('general.reset')}
          </Button>
        </div>
      )}
    </>
  );
};
